import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filename"]

  updateLabel(event) {
    const fileInput = event.target
    const wrapper = this.element
    const fileName = fileInput.files.length > 0 ? fileInput.files[0].name : "Aucun fichier sélectionné"

    this.filenameTarget.textContent = fileName  
    var remover =  document.getElementById(fileInput.dataset.removerId);
    remover.value = fileName
    remover.textContent = fileName 
 
    if (fileInput.files.length > 0) {
      wrapper.classList.add("file-selected")
    } else {
      wrapper.classList.remove("file-selected")
    }
  }
}
